export const toSet = async (source) => {
    const set = new Set();
    for await (const item of source) {
        set.add(item);
    }
    return set;
};
